import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "unassigned",
  "use": "unassigned-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"unassigned\"><path d=\"M16 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm0-14c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm13 28c-.6 0-1-.4-1-1v-4.2c0-2.6-2.2-4.8-4.8-4.8H8.8C6.2 22 4 24.2 4 26.8V31c0 .6-.4 1-1 1s-1-.4-1-1v-4.2C2 23 5 20 8.8 20h14.4c3.7 0 6.8 3 6.8 6.8V31c0 .6-.4 1-1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol